__webpack_require__.p = "https://my-blob-resource.s3.bitiful.net/";